import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Tasks from "./components/Tasks";
import AddTask from "./components/AddTask";
import Footer from "./components/Footer";
import About from "./components/About";

// Change appURL to "" when local
const appURL = "/task-tracker";
const dbURL = "dbconnect.php/";
// const appURL = process.env.REACT_APP_URL;
// const dbURL = process.env.REACT_APP_DB_URL;

const App = () => {
    const [showAddTask, setShowAddTask] = useState(true);
    const [tasks, setTasks] = useState([]);

    useEffect(() => {
        const getTasks = async () => {
            const tasksFromServer = await fetchTasks();
            setTasks(tasksFromServer);
        };

        getTasks();
    }, []);

    const fetchTasks = async () => {
        try {
            const res = await fetch(dbURL, {
                method: "GET",
                headers: { "Content-type": "application/json" },
            });

            if (!res.ok) {
                const errorResponse = await res.json();
                console.error("Error response:", errorResponse);
                return [];
            }

            const data = await res.json();
            console.log(data.message);

            let tasks = data.tasks;

            if (tasks) {
                tasks.forEach((task) => {
                    task.reminder = parseInt(task.reminder);
                });
            } else {
                tasks = [];
            }

            return tasks;
        } catch (error) {
            console.error("Fetch error:", error);
            return [];
        }
    };

    const fetchTask = async (id) => {
        const res = await fetch(dbURL + `?id=${id}`, {
            method: "GET",
            headers: { "Content-type": "application/json" },
        });

        if (!res.ok) {
            const errorResponse = await res.json();
            console.error("Error response:", errorResponse);
            return null;
        }

        const data = await res.json();

        console.log(data.message);
        return data.task;
    };

    const handleAddTask = async (task) => {
        try {
            const res = await fetch(dbURL, {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify(task),
            });

            if (!res.ok) {
                const errorResponse = await res.json();
                console.error("Error response:", errorResponse);
            }

            const data = await res.json();

            // Add task to display using response data
            const newTask = {
                id: data.taskId,
                ...task,
            };

            let newTaskList = [...tasks, newTask];
            console.log(newTaskList);
            let orderedTasks = [...tasks, newTask].sort((a, b) => {
                let dateA = new Date(a.day);
                let dateB = new Date(b.day);
                return dateA - dateB;
            });

            console.log(orderedTasks);

            setTasks(orderedTasks);
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    const handleDeleteTask = async (taskId) => {
        try {
            const res = await fetch(dbURL + `${taskId}`, {
                method: "DELETE",
                headers: { "Content-type": "application/json" },
            });

            if (!res.ok) {
                const errorResponse = await res.json();
                console.error("Error response:", errorResponse);
            }

            // Remove the task from display
            console.log("Task deleted!");
            setTasks(tasks.filter((task) => task.id !== taskId));
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    const toggleReminder = async (taskId) => {
        const taskToToggle = await fetchTask(taskId);

        let updatedReminder = 0;
        let reminder = parseInt(taskToToggle.reminder);
        if (reminder === 0) updatedReminder = 1;

        const updatedTask = { ...taskToToggle, reminder: updatedReminder };

        const res = await fetch(dbURL + `${taskId}`, {
            method: "PUT",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(updatedTask),
        });

        if (!res.ok) {
            const errorResponse = await res.json();
            console.error("Error response:", errorResponse);
        }

        const data = await res.json();

        console.log(data.message);

        setTasks(
            tasks.map((task) =>
                task.id === taskId
                    ? { ...task, reminder: updatedReminder }
                    : task
            )
        );
    };

    return (
        <div className="container">
            <Header
                appURL={appURL}
                onShowAddTask={() => setShowAddTask(!showAddTask)}
                showAddTask={showAddTask}
            />
            <Routes>
                <Route
                    path={appURL + "/"}
                    element={
                        <>
                            {showAddTask && (
                                <AddTask onAddTask={handleAddTask} />
                            )}
                            {tasks.length > 0 ? (
                                <Tasks
                                    tasks={tasks}
                                    onDeleteTask={handleDeleteTask}
                                    onToggleReminder={toggleReminder}
                                />
                            ) : (
                                <p className="no-tasks">No tasks to show!</p>
                            )}
                            <Footer appURL={appURL} />
                        </>
                    }
                />
                <Route
                    path={appURL + "/about"}
                    element={<About appURL={appURL} />}
                />
            </Routes>
        </div>
    );
};

export default App;
